import { Injectable } from '@angular/core';
import { SessionService } from './session.service';

interface IPayload {
  userRoleId: number
  url: string
}

@Injectable()
export class PermissionService {
  private readonly fullPermission: number[] = [1, 2, 3, 4, 5, 6, 7, 8, 14];

  private readonly urlToAccess: string[] = [
    '/complete-registration',
    '/documents-verification',
  ];

  constructor(
    private readonly sessionService: SessionService
  ) {}

  /**
   *
   * check if user Role can access this page
   *
   * method isGranted
   * @param userRole
   */
  isGranted(userRoleId: number, url: string): boolean {

    const payload: IPayload = {
      userRoleId: userRoleId,
      url
    }

    if (this.checkUserRole(payload))
      return true;
    return false;
  }

  /**
   *
   * further check if user Role can access this page
   *
   * method checkUserRole
   * @param userRole
   */
  private checkUserRole(payload: IPayload): boolean {

    let result = false;
    switch (payload.userRoleId) {
      case 7:
          result = true;
        break;

      case 9:
          result = payload.url === '/complete-registration' ? true : false;
        break;

      case 11:
          result = payload.url === '/documents-verification' ? true : false;
        break;

      case 12:
          result = true;
        break;

      default:
        break;
    }

    return result;
  }

  private checkUrl(url: string): boolean {
    let result = false;
    for (const path of this.urlToAccess) {
        if (url.indexOf(path) !== -1) result = true;
        break;
    }
    return result;
  }

  isAllowed(): boolean {
    // PMM-247
    return (
      this.sessionService.getRoleId() === 1 ||
      this.sessionService.getRoleId() === 2 ||
      this.sessionService.getRoleId() === 3 ||
      this.sessionService.getRoleId() === 4 ||
      this.sessionService.getRoleId() === 5 ||
      this.sessionService.getRoleId() === 6 ||
      this.sessionService.getRoleId() === 7 ||
      this.sessionService.getRoleId() === 8 ||
      this.sessionService.getRoleId() === 13 ||
      this.sessionService.getRoleId() === 14
    ) && this.sessionService.hasToken()
  }
}
